export default {"src":"/_next/static/media/icon-helveticor-secondary.4c45957f.svg","height":19,"width":136,"blurWidth":0,"blurHeight":0};